import { FormattedMessage, useIntl } from 'react-intl';
import useUser from '@alltrails/context/hooks/useUser';
import MapsTwoD from '@alltrails/denali/icons/MapsTwoD';
import MapsThreeD from '@alltrails/denali/icons/MapsThreeD';
import IconButton from '@alltrails/denali/components/IconButton';
import { useState } from 'react';
import SignUpModal from '@alltrails/user-auth/components/SignUpModal';
import PlusFeatureUpsellModal from '@alltrails/upsell/components/UpsellSystem/FeatureUpsell/PlusFeatureUpsellModal';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import { useDispatch, useSelector } from '../../redux';
import { updateIs3dActive } from '../../redux/reducer';
import { styleSupports3d } from '../../utils/styleIdHelpers';
import TerrainInstructionsToast from '../TerrainInstructionsToast';
import headerImageSrc from './3d-upsell.avif';

type TerrainButtonProps = {
  onClick?: () => void;
};

const TerrainButton = ({ onClick }: TerrainButtonProps) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const user = useUser();
  const isMobile = useIsMobileSizedScreen();
  const [isSignUpModalOpen, setIsSignUpModalOpen] = useState(false);
  const [isThreeDMapsUpsellModalOpen, setIsThreeDMapsUpsellModalOpen] = useState(false);

  const { baseStyleId, is3dActive } = useSelector(state => ({
    baseStyleId: state.map.baseStyleId,
    is3dActive: state.map.is3dActive
  }));

  return styleSupports3d(baseStyleId) ? (
    <>
      <IconButton
        icon={is3dActive ? { Component: MapsTwoD } : { Component: MapsThreeD }}
        onClick={() => {
          onClick?.();
          if (user?.featureEntitlements?.includes('three_d_map')) {
            dispatch(updateIs3dActive(is3dActive ? false : true));
          } else {
            if (!user) {
              setIsSignUpModalOpen(true);
            } else {
              setIsThreeDMapsUpsellModalOpen(true);
            }
          }
        }}
        testId="3d-toggle"
        title={is3dActive ? intl.formatMessage({ defaultMessage: 'Disable 3D map' }) : intl.formatMessage({ defaultMessage: 'Enable 3D map' })}
        variant="elevated"
      />
      {!isMobile && <TerrainInstructionsToast />}
      {isSignUpModalOpen && (
        <SignUpModal
          closeModal={() => setIsSignUpModalOpen(false)}
          isOpen={isSignUpModalOpen}
          onSuccess={user => {
            if (!user?.featureEntitlements?.includes('three_d_map')) {
              setIsThreeDMapsUpsellModalOpen(true);
            }
            setIsSignUpModalOpen(false);
          }}
          trigger="three d maps tapped"
          upsellTrigger="three d maps tapped"
        />
      )}
      {isThreeDMapsUpsellModalOpen && (
        // https://www.figma.com/design/PtYSSpohQ9rL7ZWCcdsYJK/2025-Upsell-System?node-id=1869-64624&m=dev
        <PlusFeatureUpsellModal
          headerImageSrc={headerImageSrc}
          heading={<FormattedMessage defaultMessage="View trail elevation and terrain in 3D" />}
          isOpen={isThreeDMapsUpsellModalOpen}
          onCloseRequest={() => setIsThreeDMapsUpsellModalOpen(false)}
          promoEligibleHeading={<FormattedMessage defaultMessage="Try 3D Maps and more for free" />}
          upsellTrigger="three d maps tapped"
        />
      )}
    </>
  ) : null;
};

export default TerrainButton;
